<template>
  <v-dialog persistent v-model="isShow" max-width="900px">
    <v-card>
      <v-flex xs10 offset-xs1 class="px-4 py-4">
        <p>
          <strong> Your file must contain "Email" and "PhoneNumber" columns.</strong>
        </p>
        <p>
          Your can change "FirstName", "LastName", "Gender", "Category", "BirthYear", "AccountantManagerEmail", "CorporateAddress",
          "City", "Country", "VatId", "Company", "JobTitle", "BoothNumber", "CanReceiveMessages", "IsSuperUser", "Address".
        </p>
         <p> "IsRemovedFromKillerFeatureSearch", "SubscribeNewsletter", "SubscribeProductsUpdates", "CanReceiveMessages" these fields should be true/false. </p>
         <p>Accepted formats <strong>.csv/.xlsx</strong>.</p>

      </v-flex>
      <v-flex class="pb-4 text-xs-center">
        <e-upload
          color="primary"
          :extensions="['.csv', '.xlsx']"
          :url="uploadUrl"
          method="patch"
          padding="pb-0"
        />
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'
  import EUpload from '@/components/shared/Upload'
  import { api } from '@/modules/api'

  export default {
    name: 'UploadWithExcel',
    components: {
      EUpload
    },
    props: {
      isShowModal: {
        type: Boolean,
        required: true
      }
    },
    data () {
      return {
        isShow: false,
        file: null,
        uploadUrl: api.massAttendeeActions.patchAttendeeViaExcel()
      }
    },
    watch: {
      isShow (val) {
        if (!val) this.$emit('close')
      }
    },
    methods: {
      ...mapActions([
        'updateAttendeeViaExcel'
      ]),
      close () {
        this.$emit('close')
      }
    },
    created () {
      this.isShow = this.isShowModal
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/Upload/uploadWithExcel.vue